import { CButton, CCard, CFormSelect } from '@coreui/react'
import useAxios from 'axios-hooks'
import React, { useContext, useEffect, useState } from 'react'
import DatePicker from 'react-date-picker'
import { useParams, useLocation } from 'react-router-dom'
import DateIcon from 'src/assets/Content-Icons/dateicon'
import { CustomDescriptionBox } from 'src/components'
import CustomMultiSelect from 'src/components/customMultiSelect/customMultiSelect'
import TimePicker from 'src/components/timePicker/timePicker'
import ToggleButtons from 'src/components/toggleButtons/toggleButtons'
import { AppContext } from 'src/views/context/app'
import { activeArray, concatDateTimeToIso, raiseToast } from 'src/views/utils/helper'
import {
  AUDIENCE_API,
  CAMPAIGN_API,
  CAMPAIGN_CUSTOM_META_DATA_API,
  EMAIL_TEMPLATES_API,
  USER_API,
} from 'src/views/utils/urls'
import CampaignScheduleCard from './campaignScheduleCard'
import CustomMetadata from 'src/components/CustomMetadata/CustomMetadata'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router-dom'

const CreateCampaign = () => {
  const { campaignId } = useParams()
  const location = useLocation()
  const { setLoader } = useContext(AppContext)
  const isEdit = location.pathname.includes('/campaign/edit/')
  const history = useHistory()

  const [campaignName, setCampaignName] = useState('')
  const [description, setDescription] = useState('')
  const [isEvergreen, setIsEvergreen] = useState(false)
  const [startDate, setStartDate] = useState(new Date())
  const [startTime, setStartTime] = useState()
  const [endDate, setEndDate] = useState(new Date())
  const [endTime, setEndTime] = useState()

  const [customMetadata, setCustomMetadata] = useState({})

  const [emailTempMaster, setEmailTempMaster] = useState([])
  const [audienceMaster, setAudienceMaster] = useState([])
  const [audience, setAudience] = useState([])
  const [emailTemplate, setEmailTemplate] = useState('')

  const [cmsUserMaster, setCmsUserMaster] = useState([])
  const [userGroupMaster, setUserGroupMaster] = useState([])
  const [cmsUser, setCmsUser] = useState([])
  const [userGroup, setUserGroup] = useState([])

  const [scheduleData, setScheduleData] = useState([
    {
      start_date: concatDateTimeToIso(
        new Date(),
        new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
      ),
      end_date: concatDateTimeToIso(
        new Date(),
        new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
      ),
      frequency: 'DAILY',
    },
  ])

  const [errorData, setErrorData] = useState({})

  const [{ data: campaignData, loading: campaignDataLoading }, campaignDataCall] = useAxios(
    {
      url: CAMPAIGN_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: campaignCreate, loading: campaignCreateLoading }, campaignCreateCall] = useAxios(
    {
      url: CAMPAIGN_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: campaignUpdate, loading: campaignUpdateLoading }, campaignUpdateCall] = useAxios(
    {
      url: CAMPAIGN_API,
      method: 'put',
    },
    { manual: true },
  )

  const [{ data: emailTemplateData, loading: emailTemplateDataLoading }, emailTemplateDataCall] =
    useAxios(
      {
        url: EMAIL_TEMPLATES_API,
        method: 'get',
      },
      { manual: true },
    )

  const [{ data: audienceData, loading: audienceDataLoading }, audienceDataCall] = useAxios(
    {
      url: AUDIENCE_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: cmsUserList, loading: cmsUserListLoading }, cmsUserListCall] = useAxios(
    {
      url: `${USER_API}/cms-user`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: userGroupList, loading: userGroupListLoading }, userGroupListCall] = useAxios(
    {
      url: `${USER_API}/user-group`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: customMetadataList, loading: customMetadataLoading }, customMetadataCall] =
    useAxios(
      {
        url: CAMPAIGN_CUSTOM_META_DATA_API,
        method: 'get',
      },
      { manual: true },
    )

  useEffect(() => {
    if (isEdit && campaignId) {
      campaignDataCall({
        params: {
          campaign_id: campaignId,
        },
      })
    }
    if (!isEdit) {
      setStartTime(new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }))
      setEndTime(new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }))
      setCampaignName(location?.state?.name ? location.state.name : '')
    }
  }, [location])

  useEffect(async () => {
    customMetadataCall()
    userGroupListCall()
    cmsUserListCall()
    emailTemplateDataCall()
    let pageSize = await audienceDataCall({
      params: {
        page: 1,
        page_size: 1,
      },
    })
    await audienceDataCall({
      params: {
        page: 1,
        page_size: pageSize.data?.total,
      },
    })
  }, [])

  useEffect(() => {
    setLoader(
      campaignDataLoading ||
        audienceDataLoading ||
        emailTemplateDataLoading ||
        cmsUserListLoading ||
        userGroupListLoading ||
        customMetadataLoading ||
        campaignUpdateLoading ||
        campaignCreateLoading,
    )
  }, [
    campaignDataLoading,
    audienceDataLoading,
    emailTemplateDataLoading,
    cmsUserListLoading,
    userGroupListLoading,
    customMetadataLoading,
    campaignUpdateLoading,
    campaignCreateLoading,
  ])

  useEffect(() => {
    if (
      campaignData &&
      campaignData.success &&
      !isEmpty(audienceMaster) &&
      !isEmpty(cmsUserMaster) &&
      !isEmpty(userGroupMaster)
    ) {
      setCampaignName(campaignData?.data?.name)
      setDescription(campaignData?.data?.description)
      setIsEvergreen(campaignData?.data?.is_evergreen === true)
      if (campaignData?.data?.start_date) {
        setStartDate(new Date(campaignData.data['start_date'] + 'Z'))
        setStartTime(
          new Date(campaignData.data['start_date'] + 'Z').toLocaleTimeString('en-UK', {
            timeStyle: 'short',
            hour12: false,
          }),
        )
      }
      if (campaignData?.data?.end_date && !campaignData?.data?.is_evergreen) {
        setEndDate(new Date(campaignData.data['end_date'] + 'Z'))
        setEndTime(
          new Date(campaignData.data['end_date'] + 'Z').toLocaleTimeString('en-UK', {
            timeStyle: 'short',
            hour12: false,
          }),
        )
      }

      if (campaignData?.data?.is_evergreen) {
        setEndTime(new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }))
      }

      setCustomMetadata(campaignData?.data?.custom_metadata)

      if (!isEmpty(campaignData?.data?.campaign_audience)) {
        let data = campaignData?.data?.campaign_audience
        let tempArr = []
        for (let i = 0; i < data.length; i++) {
          const id = data[i]

          let obj = audienceMaster.find((info) => info._id === id)
          if (obj) {
            tempArr.push(obj)
          }
        }

        setAudience([...tempArr])
      }
      setEmailTemplate(campaignData?.data?.template)

      if (!isEmpty(campaignData?.data?.cms_users)) {
        let data = campaignData?.data?.cms_users
        let tempArr = []
        for (let i = 0; i < data.length; i++) {
          const id = data[i]

          let obj = cmsUserMaster.find((info) => info._id === id)
          if (obj) {
            tempArr.push(obj)
          }
        }

        setCmsUser([...tempArr])
      }
      if (!isEmpty(campaignData?.data?.user_groups)) {
        let data = campaignData?.data?.user_groups
        let tempArr = []
        for (let i = 0; i < data.length; i++) {
          const id = data[i]
          let obj = userGroupMaster.find((info) => info._id === id)
          if (obj) {
            tempArr.push(obj)
          }
        }

        setUserGroup([...tempArr])
      }

      setScheduleData(campaignData?.data?.schedule)
    }
  }, [campaignData, audienceMaster, cmsUserMaster, userGroupMaster])

  useEffect(() => {
    if (campaignCreate && campaignCreate.success) {
      raiseToast('success', 'Campaign Created Successfully')
      history.push(`/campaign/list`)
    }
  }, [campaignCreate])

  useEffect(async () => {
    if (campaignUpdate && campaignUpdate.success) {
      raiseToast('success', 'Campaign Updated Successfully!')
      history.push(`/campaign/list`)
    }
  }, [campaignUpdate])

  useEffect(() => {
    if (userGroupList && userGroupList.success) {
      setUserGroupMaster(userGroupList.data)
    }
  }, [userGroupList])

  useEffect(() => {
    if (cmsUserList && cmsUserList.success) {
      setCmsUserMaster(cmsUserList.data)
    }
  }, [cmsUserList])

  useEffect(() => {
    if (emailTemplateData && emailTemplateData.success) {
      setEmailTempMaster(emailTemplateData.data.filter((info) => info?.template_type === 'CUSTOM'))
    }
  }, [emailTemplateData])

  useEffect(() => {
    if (audienceData && audienceData.success) {
      setAudienceMaster(audienceData.data)
    }
  }, [audienceData])

  const handleRemoveSlot = (index) => {
    let tempArr = scheduleData.filter((ele, idx) => idx !== index)
    setScheduleData([...tempArr])
  }

  const handleAddSlot = () => {
    setScheduleData((prev) => [
      ...prev,
      {
        start_date: concatDateTimeToIso(
          new Date(),
          new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
        ),
        end_date: concatDateTimeToIso(
          new Date(),
          new Date().toLocaleTimeString('en-UK', { timeStyle: 'short', hour12: false }),
        ),
        frequency: 'DAILY',
      },
    ])
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (campaignName.trim().length === 0) {
      isFormValid = false
      temp.campaignName = 'Campaign name cannot be empty!'
    }

    if (description.trim().length === 0) {
      isFormValid = false
      temp.description = 'Description name cannot be empty!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleCreate = () => {
    if (!validateInfo()) return

    let payload = {
      name: campaignName,
      description: description,
      start_date: concatDateTimeToIso(startDate, startTime),
      is_evergreen: isEvergreen,
      template: emailTemplate,
      campaign_audience: audience.map((info) => info._id),
      cms_users: cmsUser.map((info) => info._id),
      user_groups: userGroup.map((info) => info._id),
      custom_metadata: customMetadata,
      schedule: scheduleData,
    }

    if (!isEvergreen) {
      payload['end_date'] = concatDateTimeToIso(endDate, endTime)
    }

    campaignCreateCall({
      data: payload,
    })
  }

  const handleUpdate = () => {
    if (!validateInfo()) return
    let payload = {
      name: campaignName,
      description: description,
      is_evergreen: isEvergreen,
      start_date: concatDateTimeToIso(startDate, startTime),
      template: emailTemplate,
      campaign_audience: audience.map((info) => info._id),
      cms_users: cmsUser.map((info) => info._id),
      user_groups: userGroup.map((info) => info._id),
      custom_metadata: customMetadata,
      schedule: scheduleData,
    }

    if (!isEvergreen) {
      payload['end_date'] = concatDateTimeToIso(endDate, endTime)
    }

    campaignUpdateCall({
      params: {
        campaign_id: campaignId,
      },
      data: payload,
    })
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <h4>Campaign</h4>
          <p>Following are the Campaign which are already in your store.</p>
        </div>
      </div>
      <CCard
        style={{
          height: '68vh',
          overflowX: 'hidden',
          paddingLeft: '2.135vw',
          paddingRight: '2.135vw',
          paddingTop: '2.5vw',
        }}
        className="custom-scrollbar-vertical "
      >
        <div className="w-100">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
            className="w-100 rounded pl-4"
          >
            Basic Properties
          </div>
          <div
            className="w-100 pl-4 pr-1 d-flex justify-content-between "
            style={{ marginTop: '1.355vw' }}
          >
            <div style={{ width: '45%' }}>
              <div>
                <h6 style={{ fontSize: '.8333vw' }}>
                  Campaign Name <span style={{ color: 'red' }}>*</span>
                </h6>
                <CustomDescriptionBox
                  limit={50}
                  rows={1}
                  value={campaignName}
                  onChange={(value) => {
                    setCampaignName(value)
                  }}
                  isMandatory={true}
                  errorText={errorData[`campaignName`]}
                  style={{ fontSize: '13px' }}
                  useFormInput={true}
                />
              </div>
              <div>
                <h6 style={{ fontSize: '.8333vw' }}>
                  Description <span style={{ color: 'red' }}>*</span>
                </h6>
                <CustomDescriptionBox
                  limit={150}
                  rows={2}
                  value={description}
                  onChange={(value) => {
                    setDescription(value)
                  }}
                  isMandatory={true}
                  errorText={errorData[`description`]}
                  style={{ fontSize: '13px' }}
                />
              </div>
            </div>
            <div style={{ width: '49%' }} className="">
              <div className="d-flex justify-between">
                <div>
                  <h6 style={{ fontSize: '.8333vw' }}>
                    Start Date <span style={{ color: 'red' }}>*</span>
                  </h6>
                  <div className="d-flex">
                    <div>
                      <DatePicker
                        className="date-picker-pricing"
                        onChange={setStartDate}
                        value={startDate}
                        minDate={startDate ? '' : new Date()}
                        format="dd/MM/y"
                        calendarIcon={<DateIcon />}
                      />
                    </div>
                    <div style={{ marginLeft: '.5vw', position: 'relative' }}>
                      <TimePicker time={startTime} setTime={setStartTime} />
                    </div>
                  </div>
                </div>
                <div>
                  <h6 style={{ fontSize: '.8333vw' }}>
                    End Date <span style={{ color: 'red' }}>*</span>
                  </h6>
                  <div className="d-flex">
                    <div>
                      <DatePicker
                        className="date-picker-pricing"
                        onChange={setEndDate}
                        value={endDate}
                        minDate={startDate}
                        format="dd/MM/y"
                        calendarIcon={<DateIcon />}
                        disabled={isEvergreen}
                      />
                    </div>
                    <div style={{ marginLeft: '.5vw', position: 'relative' }}>
                      <TimePicker time={endTime} setTime={setEndTime} disabled={isEvergreen} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-3">
                <h6 style={{ fontSize: '.8333vw' }}>Evergreen Campaign</h6>
                <ToggleButtons
                  toggle={isEvergreen}
                  setToggle={setIsEvergreen}
                  trueOption={'Enable'}
                  falseOption={'Disable'}
                  toggleWidth="26%"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-100 mt-4">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
            className="w-100 rounded pl-4"
          >
            Custom Properties
          </div>
          <div
            className="w-100 pl-4 pr-1 d-flex justify-content-between "
            style={{ marginTop: '0.3vw' }}
          >
            {customMetadataList && !isEmpty(customMetadataList?.data) && (
              <CustomMetadata
                isEdit={isEdit}
                editData={isEdit ? { custom_metadata: customMetadata } : {}}
                customMetadataMaster={activeArray(customMetadataList.data)}
                customPayload={customMetadata}
                setCustomPayload={setCustomMetadata}
                column={3}
              />
            )}
          </div>
        </div>
        <div className="w-100 mt-4">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
            className="w-100 rounded pl-4"
          >
            Audience and template
          </div>
          <div
            className=" pl-4 pr-1 d-flex justify-content-between "
            style={{ marginTop: '1.355vw', width: '65%' }}
          >
            <div style={{ width: '45%' }} className="">
              <h6 style={{ fontSize: '.8333vw' }}>Select Audience</h6>
              <CustomMultiSelect
                selectedValue={audience}
                optionsData={audienceMaster}
                onChange={setAudience}
                labelKey="name"
              />
            </div>
            <div style={{ width: '45%' }} className="">
              <h6 style={{ fontSize: '.8333vw' }}>Select Template</h6>
              <CFormSelect
                value={emailTemplate}
                onChange={(e) => {
                  setEmailTemplate(e.target.value)
                }}
                size="sm"
              >
                <option value="" selected disabled>
                  Select Template
                </option>
                {emailTempMaster.map((info, idx) => (
                  <option key={idx} value={info._id}>
                    {info?.name}
                  </option>
                ))}
              </CFormSelect>
            </div>
          </div>
        </div>
        <div className="w-100 mt-4">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
            className="w-100 rounded pl-4"
          >
            Visibility and Permissions
          </div>
          <div
            className=" pl-4 pr-1 d-flex justify-content-between "
            style={{ marginTop: '1.355vw', width: '65%' }}
          >
            <div style={{ width: '45%' }} className="">
              <h6 style={{ fontSize: '.8333vw' }}>CMS Users</h6>
              <CustomMultiSelect
                selectedValue={cmsUser}
                optionsData={cmsUserMaster}
                onChange={setCmsUser}
                labelKey="name"
              />
            </div>
            <div style={{ width: '45%' }} className="">
              <h6 style={{ fontSize: '.8333vw' }}>CMS User Groups</h6>
              <CustomMultiSelect
                selectedValue={userGroup}
                optionsData={userGroupMaster}
                onChange={setUserGroup}
                labelKey="name"
              />
            </div>
          </div>
        </div>
        <div className="w-100 mt-4">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
            className="w-100 rounded pl-4"
          >
            Scheduling
          </div>
          <div
            className="w-100 pl-4 pr-1 d-flex justify-content-between "
            style={{ marginTop: '1.355vw' }}
          >
            <div style={{ width: '85%' }}>
              {!isEmpty(scheduleData) &&
                scheduleData.map((item, idx) => (
                  <CampaignScheduleCard
                    key={idx}
                    index={idx}
                    data={item}
                    setScheduleData={setScheduleData}
                    scheduleData={scheduleData}
                    onDelete={() => handleRemoveSlot(idx)}
                  />
                ))}
            </div>
            <div>
              <CButton
                className="text-white"
                style={{
                  color: 'white',
                  backgroundColor: '#20211c',
                  border: '1px solid #bdbdbd',
                  borderRadius: '5px',
                  width: '6.8vw',
                  height: '2.4vw',
                  fontSize: '.75vw',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
                onClick={handleAddSlot}
              >
                ADD SLOT
              </CButton>
            </div>
          </div>
        </div>
      </CCard>
      <div className="w-100 d-flex justify-content-end mt-2">
        <CButton
          className="px-3 mx-4 text-black border"
          onClick={() => {
            history.push(`/campaign/list`)
          }}
          style={{
            pointerEvents: 'auto',
            fontSize: '18px',
            background: 'inherit',
            border: 'solid 1.5px #bdbdbd',
          }}
        >
          Cancel
        </CButton>
        <CButton
          className="text-white px-3"
          onClick={isEdit ? () => handleUpdate() : () => handleCreate()}
          style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
        >
          Run Campaign
        </CButton>
      </div>
    </div>
  )
}

export default CreateCampaign
